<template>
  <button class="card-button">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'CardButton',
}
</script>

<style lang="scss" scoped>
.card-button {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 48px;
  font-size: 15px;
  line-height: 1;
  color: $color-grey-dark-2;
  background-color: rgba($color-white, 0.85);
}
</style>
